import React from 'react';
import AcademicContractTerms, {
  AcademicContractTermsProps,
} from '../AcademicContractTerms/AcademicContractTerms.component';
import NonAcademicContractTerms, {
  NonAcademicContractTermsProps,
} from '../NonAcademicContractTerms/NonAcademicContractTerms.component';
import { VacancyType } from 'searchality-data';

type ContractTermsProps = {
  vacancyType: VacancyType;
} & AcademicContractTermsProps &
  NonAcademicContractTermsProps;

const ContractTerms: React.FC<ContractTermsProps> = (props) => {
  const {
    vacancyType,
    studentContractDays,
    studentNonContractDays,
    contractDays,
    contractDaysDetails,
  } = props;

  const renderContractTerms =
    contractDays ||
    contractDaysDetails ||
    studentContractDays ||
    studentNonContractDays;

  if (!renderContractTerms) {
    return null;
  }

  return (
    <li>
      {vacancyType === VacancyType.ACADEMIC ? (
        <AcademicContractTerms
          studentContractDays={studentContractDays}
          studentNonContractDays={studentNonContractDays}
        />
      ) : (
        <NonAcademicContractTerms
          contractDays={contractDays}
          contractDaysDetails={contractDaysDetails}
        />
      )}
    </li>
  );
};

export default ContractTerms;
